export default {
  'aiAgentSchedule.form.aiAgent': 'Agente IA',
  'aiAgentSchedule.form.instructions': 'Instrucciones',
  'aiAgentSchedule.form.instructions.edit': 'Editar instrucciones',
  'aiAgentSchedule.form.instructions.placeholder':
    'Describe qué debe hacer el agente en cada ejecución…',
  'aiAgentSchedule.form.repeat': 'Repetir',
  'aiAgentSchedule.form.repeat.hourly': 'Cada hora',
  'aiAgentSchedule.form.repeat.daily': 'Cada día',
  'aiAgentSchedule.form.repeat.weekly': 'Cada semana',
  'aiAgentSchedule.form.repeat.monthly': 'Cada mes',
  'aiAgentSchedule.form.repeat.businessDay': 'Cada día hábil',
  'aiAgentSchedule.form.repeat.custom': 'Personalizado…',
  'aiAgentSchedule.form.repeat.manual': 'Solo manual',
  'aiAgentSchedule.form.repeat.instant': 'Solo manual',
  'aiAgentSchedule.form.repeat.automated': 'Solo manual',
  'aiAgentSchedule.form.repeat.none': 'Solo manual',
  'aiAgentSchedule.form.repeat.nonscheduled.hint':
    'Modo solo manual: no se programan ejecuciones automáticas. Usa Ejecutar cuando quieras lanzar el trabajo.',
  'aiAgentSchedule.form.repeat.none.hint':
    'Modo solo manual: no se programan ejecuciones automáticas. Usa Ejecutar cuando quieras lanzar el trabajo.',
  'aiAgentSchedule.form.every': 'Cada',
  'aiAgentSchedule.form.unit': 'Unidad',
  'aiAgentSchedule.form.starts': 'Empieza',
  'aiAgentSchedule.form.starts.now': 'Ahora mismo',
  'aiAgentSchedule.form.starts.tomorrow': 'Mañana',
  'aiAgentSchedule.form.starts.custom': 'Elegir un día…',
  'aiAgentSchedule.form.starts.hint':
    'Define cuándo se materializa la primera ejecución automática. Luego se repite según la frecuencia.',
  'aiAgentSchedule.form.atTime': 'A las',
  'aiAgentSchedule.form.onDay': 'El día',
  'aiAgentSchedule.form.firstRun': 'Primera ejecución',
  'aiAgentSchedule.form.section.context': 'Contexto',
  'aiAgentSchedule.form.context': 'Contexto adicional',
  'aiAgentSchedule.form.context.hint':
    'Opcional. Vincula una tarea y documentos para darle más contexto al agente en cada ejecución.',
  'aiAgentSchedule.form.userTask': 'Tarea vinculada',
  'aiAgentSchedule.form.documents': 'Documentos',
  'aiAgentSchedule.form.documents.add': 'Agregar documentos',
  'aiAgentSchedule.form.documents.empty': 'Haz clic o arrastra uno o más archivos',
  'aiAgentSchedule.form.section.schedule': 'Programación',
  'aiAgentSchedule.form.section.sharing': 'Acceso y colaboración',
  'aiAgentSchedule.form.section.execution': 'Ejecución',
  'aiAgentSchedule.accessControl.title': 'Quién puede consultar y ejecutar',
  'aiAgentSchedule.accessControl.help':
    'Pueden consultar el trabajo y su histórico y ejecutarlo manualmente, pero no editarlo. No se agregan al chat de las ejecuciones.',
  'aiAgentSchedule.accessControl.open': 'Configurar acceso',
  'aiAgentSchedule.accessControl.summary.empty': 'Solo el propietario y los colaboradores',
  'aiAgentSchedule.accessControl.summary.count':
    '{count, plural, one {# audiencia configurada} other {# audiencias configuradas}}',
  'aiAgentSchedule.collaborators.title': 'Quién puede colaborar',
  'aiAgentSchedule.collaborators.help':
    'Pueden consultar, ejecutar y modificar el trabajo y ver todo su histórico. También participan en el chat de las nuevas ejecuciones. Los cambios futuros no afectan ejecuciones anteriores.',
  'aiAgentSchedule.collaborators.open': 'Configurar colaboradores',
  'aiAgentSchedule.collaborators.summary.empty': 'Sin colaboradores',
  'aiAgentSchedule.collaborators.summary.count':
    '{count, plural, one {# colaborador} other {# colaboradores}}',
  'aiAgentSchedule.sharing.createHint':
    'Guarda el trabajo primero para configurar acceso y colaboradores, o configúralos ahora y se enviarán al crear.',
  'aiAgentSchedule.sharing.draft.access': 'Acceso (borrador)',
  'aiAgentSchedule.sharing.draft.collaborators': 'Colaboradores (borrador)',
  'aiAgentSchedule.form.hero.kicker.add': 'Nuevo trabajo',
  'aiAgentSchedule.form.hero.kicker.edit': 'Editar trabajo',
  'aiAgentSchedule.form.hero.summary': 'Dile a tu agente qué hacer y cuándo repetirlo.',
  'aiAgentSchedule.form.name.placeholder': '¿Cómo se llama este trabajo?',
  'aiAgentSchedule.form.cta.add': 'Crear trabajo',
  'aiAgentSchedule.form.cta.edit': 'Guardar cambios',
  'aiAgentSchedule.form.nextRun': 'Próxima ejecución',
  'aiAgentSchedule.form.nextRun.manual': 'Solo al ejecutar manualmente',
  'aiAgentSchedule.form.nextExecutionDate': 'Próxima ejecución',
  'aiAgentSchedule.form.lastExecutionDate': 'Última ejecución',
  'aiAgentSchedule.form.maxConcurrentExecutions': 'Máx. ejecuciones concurrentes',
  'aiAgentSchedule.form.isActive': 'Programación activa',
  'aiAgentSchedule.form.isActive.hint':
    'Actívala para programar ejecuciones automáticas. Apagada, el trabajo solo se ejecuta manualmente.',
  'aiAgentSchedule.form.history': 'Historial',
  'aiAgentSchedule.tasks.title': 'Historial de ejecuciones',
  'aiAgentSchedule.tasks.description':
    'Ejecuciones materializadas desde este trabajo. Puedes ejecutar, pausar o cancelar según el estado.',
  'aiAgentSchedule.tasks.triggerType': 'Origen',
  'aiAgentSchedule.tasks.action.run': 'Ejecutar',
  'aiAgentSchedule.tasks.action.pause': 'Pausar',
  'aiAgentSchedule.tasks.pause.confirmTitle': '¿Pausar esta ejecución?',
  'aiAgentSchedule.tasks.pause.confirmContent':
    'Si está en cola se pausará de inmediato. Si está en curso, se solicitará una pausa cooperativa.',
  'aiAgentSchedule.tasks.delete.confirmTitle': '¿Cancelar / eliminar esta ejecución?',
  'aiAgentSchedule.tasks.delete.confirmContent':
    'Las ejecuciones en curso se cancelarán de forma cooperativa. El historial se conserva.',
  'aiAgentSchedule.triggerType.scheduled': 'Programada',
  'aiAgentSchedule.triggerType.manual': 'Manual',
  'aiAgentSchedule.triggerType.unknown': 'Desconocido',
  'aiAgentSchedule.tasks.requestedOperation': 'Operación solicitada',
  'aiAgentSchedule.tasks.latestActivity': 'Actividad reciente',
  'aiAgentSchedule.tasks.latestActivityAt': 'Última actividad',
  'aiAgentSchedule.tasks.currentToolName': 'Herramienta activa',
  'aiAgentSchedule.tasks.executionMode': 'Modo de ejecución',
  'aiAgentSchedule.tasks.instructions': 'Instrucciones de esta ejecución',
  'aiAgentSchedule.tasks.runtime.title': 'Actividad en vivo',
  'aiAgentSchedule.tasks.runtime.tool': 'Usando {tool}',
  'aiAgentSchedule.tasks.runtime.working': 'El agente está trabajando…',
  'aiAgentSchedule.tasks.runtime.requestedOperation':
    'Hay una operación solicitada (pausa o cancelación) en curso…',
  'aiAgentSchedule.tasks.meta': 'Datos de la ejecución',
  'aiAgentSchedule.tasks.output': 'Respuesta',
  'aiAgentSchedule.tasks.output.hint': 'Última salida del agente para esta ejecución',
  'aiAgentSchedule.tasks.output.loading': 'Cargando respuesta…',
  'aiAgentSchedule.tasks.output.empty': 'Aún no hay una respuesta disponible para este hilo.',
  'aiAgentSchedule.tasks.output.error': 'No se pudo cargar la respuesta del agente.',
  'aiAgentSchedule.tasks.output.openChat': 'Abrir en el chat',
  'aiAgentSchedule.tasks.documents': 'Documentos',
  'aiAgentSchedule.tasks.documents.hint': 'Adjuntos del hilo de esta ejecución',
  'aiAgentSchedule.tasks.documents.loading': 'Cargando documentos…',
  'aiAgentSchedule.tasks.documents.empty': 'No hay documentos adjuntos en este hilo.',
  'aiAgentSchedule.tasks.documents.error': 'No se pudieron cargar los documentos.',
  'aiAgentSchedule.requestedOperation.none': 'Ninguna',
  'aiAgentSchedule.requestedOperation.pause': 'Pausando…',
  'aiAgentSchedule.requestedOperation.cancel': 'Cancelando…',
  'aiAgentSchedule.executionMode.manualOnly': 'Solo manual',
  'aiAgentSchedule.executionMode.recurring': 'Recurrente',
  'aiAgentSchedule.run.confirmTitle': 'Ejecutar ahora',
  'aiAgentSchedule.run.confirmContent':
    'Se creará una ejecución manual de este trabajo con sus instrucciones actuales.',
  'aiAgentSchedule.run.instructionsPlaceholder':
    'Instrucciones solo para esta ejecución. Si lo dejas vacío se usan las del trabajo.',
  'aiAgentSchedule.run.instructionsLabel': 'Instrucciones para esta ejecución',
  'aiAgentSchedule.run.optional': 'Opcional',
  'aiAgentSchedule.run.overrideNote':
    'Todo lo que definas aquí aplica solo a esta ejecución; el trabajo conserva su configuración.',
  'aiAgentSchedule.run.confirmOk': 'Ejecutar',
  'aiAgentSchedule.operationType.executescheduledrun': 'Ejecución programada',
  'aiAgentSchedule.operationType.unknown': 'Operación desconocida',
};
